import React from 'react'
import { View } from 'react-native'
import { Circle, ContentLoader, Rect } from '@src/components/ContentLoader'
import { StyleService, useStyleSheet } from '@src/style/service'

interface AppointmentSchedulingLoadingContentProps {
  showSchedulingOptions?: boolean
  showCoachProfile?: boolean
}

export const AppointmentSchedulingLoadingContent = ({
  showSchedulingOptions,
  showCoachProfile,
}: AppointmentSchedulingLoadingContentProps) => {
  const styles = useStyleSheet(themedStyles)

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {showSchedulingOptions && (
          <View style={styles.segmentedControl}>
            <ContentLoader style={styles.optionsLoader}>
              <Rect x="0" y="0" width="100%" height="100%" rx="24" ry="24" />
              <Rect x="4" y="4" width="32%" height="34" rx="24" ry="24" />
              <Rect x="41%" y="13" width="18%" height="12" rx="4" ry="4" />
              <Rect x="73%" y="13" width="18%" height="12" rx="4" ry="4" />
            </ContentLoader>
          </View>
        )}

        <ContentLoader style={styles.timeZoneLoader}>
          <Circle cx="24" cy="22" r="10" />
          <Rect x="48" y="14" width="46%" height="16" rx="4" ry="4" />
        </ContentLoader>

        <View style={styles.calendarContainer}>
          <ContentLoader style={styles.calendarLoader}>
            <Rect x="12%" y="18" width="6%" height="18" rx="4" ry="4" />
            <Rect x="38%" y="18" width="24%" height="18" rx="4" ry="4" />
            <Rect x="82%" y="18" width="6%" height="18" rx="4" ry="4" />

            <Rect x="4%" y="68" width="8%" height="14" rx="4" ry="4" />
            <Rect x="18%" y="68" width="8%" height="14" rx="4" ry="4" />
            <Rect x="32%" y="68" width="8%" height="14" rx="4" ry="4" />
            <Rect x="46%" y="68" width="8%" height="14" rx="4" ry="4" />
            <Rect x="60%" y="68" width="8%" height="14" rx="4" ry="4" />
            <Rect x="74%" y="68" width="8%" height="14" rx="4" ry="4" />
            <Rect x="88%" y="68" width="8%" height="14" rx="4" ry="4" />

            <Rect x="6%" y="108" width="9%" height="22" rx="4" ry="4" />
            <Rect x="19%" y="108" width="9%" height="22" rx="4" ry="4" />
            <Rect x="32%" y="108" width="9%" height="22" rx="4" ry="4" />
            <Rect x="45%" y="108" width="9%" height="22" rx="4" ry="4" />
            <Rect x="58%" y="108" width="9%" height="22" rx="4" ry="4" />
            <Rect x="71%" y="108" width="9%" height="22" rx="4" ry="4" />
            <Rect x="84%" y="108" width="9%" height="22" rx="4" ry="4" />

            <Rect x="6%" y="148" width="9%" height="22" rx="4" ry="4" />
            <Rect x="19%" y="148" width="9%" height="22" rx="4" ry="4" />
            <Rect x="32%" y="148" width="9%" height="22" rx="4" ry="4" />
            <Rect x="45%" y="148" width="9%" height="22" rx="4" ry="4" />
            <Rect x="58%" y="148" width="9%" height="22" rx="4" ry="4" />
            <Rect x="71%" y="148" width="9%" height="22" rx="4" ry="4" />
            <Rect x="84%" y="148" width="9%" height="22" rx="4" ry="4" />

            <Rect x="6%" y="188" width="9%" height="22" rx="4" ry="4" />
            <Rect x="19%" y="188" width="9%" height="22" rx="4" ry="4" />
            <Rect x="32%" y="188" width="9%" height="22" rx="4" ry="4" />
            <Rect x="45%" y="188" width="9%" height="22" rx="4" ry="4" />
            <Rect x="58%" y="188" width="9%" height="22" rx="4" ry="4" />
            <Rect x="71%" y="188" width="9%" height="22" rx="4" ry="4" />
            <Rect x="84%" y="188" width="9%" height="22" rx="4" ry="4" />

            <Rect x="6%" y="228" width="9%" height="22" rx="4" ry="4" />
            <Rect x="19%" y="228" width="9%" height="22" rx="4" ry="4" />
            <Rect x="32%" y="228" width="9%" height="22" rx="4" ry="4" />
            <Rect x="45%" y="228" width="9%" height="22" rx="4" ry="4" />
            <Rect x="58%" y="228" width="9%" height="22" rx="4" ry="4" />
            <Rect x="71%" y="228" width="9%" height="22" rx="4" ry="4" />
            <Rect x="84%" y="228" width="9%" height="22" rx="4" ry="4" />
          </ContentLoader>
        </View>

        {showCoachProfile && (
          <ContentLoader variant="card" style={styles.coachLoader}>
            <Rect x="16" y="16" width="56" height="56" rx="28" ry="28" />
            <Rect x="88" y="18" width="42%" height="16" rx="4" ry="4" />
            <Rect x="88" y="42" width="28%" height="14" rx="4" ry="4" />
            <Rect x="88" y="66" width="36%" height="14" rx="4" ry="4" />
          </ContentLoader>
        )}

        <View style={styles.slots}>
          <ContentLoader style={styles.slotLoader}>
            <Rect x="0" y="0" width="100%" height="100%" rx="24" ry="24" />
          </ContentLoader>
          <ContentLoader style={styles.slotLoader}>
            <Rect x="0" y="0" width="100%" height="100%" rx="24" ry="24" />
          </ContentLoader>
          <ContentLoader style={styles.slotLoader}>
            <Rect x="0" y="0" width="100%" height="100%" rx="24" ry="24" />
          </ContentLoader>
        </View>
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingTop: 8,
  },
  content: {
    gap: 12,
  },
  segmentedControl: {
    borderRadius: 18,
    overflow: 'hidden',
  },
  optionsLoader: {
    height: 42,
  },
  timeZoneLoader: {
    height: 44,
  },
  calendarContainer: {
    borderWidth: 2,
    borderRadius: 8,
    borderColor: 'theme.surface.base',
    paddingVertical: 6,
  },
  calendarLoader: {
    height: 294,
  },
  coachLoader: {
    height: 88,
  },
  slots: {
    gap: 12,
  },
  slotLoader: {
    height: 50,
  },
})
